const documentTitleMixin = {
  mounted() {
    const title =
      this.getTitle(this) ||
      (this.$route || { meta: { langKey: "Pondlogs" } }).meta.langKey;
    if (title && this.$i18n) {
      document.title = `Pondlogs | ${this.$t(title)}`;
    }
  },
  methods: {
    getTitle: function(vm) {
      const { documentTitle } = vm.$options;
      if (documentTitle) {
        return typeof title === "function"
          ? documentTitle.call(vm)
          : documentTitle;
      }
    },
  },
};

export default documentTitleMixin;
